<div id="{{nameRoot}}" class="column-chart">
    <p>Vol.</p>
</div>
